module.exports = __webpack_public_path__ + "img/GS_Profiles-Kutlwano Matsheka.1b28187a.png";